import { ENRICH_SESSION } from './mutation'
import { logError } from '../../utils/logger'

/**
 * Fetches Funnel-backed person fields from the API and warms the server Redis cache.
 * @param {import('@apollo/client').ApolloClient} client
 * @returns {Promise<object>}
 */
export const enrichSession = async client => {
  try {
    const { data } = await client.mutate({ mutation: ENRICH_SESSION })
    return data?.enrichSession
  } catch (e) {
    logError(e, 'entities/session/service > enrichSession')
    throw e
  }
}
